export const SET_ACCEPT_AGREEMENT_START = 'SET_ACCEPT_AGREEMENT_START';
export const SET_ACCEPT_AGREEMENT_FULFILLED = 'SET_ACCEPT_AGREEMENT_FULFILLED';
export const SET_ACCEPT_AGREEMENT_REJECTED = 'SET_ACCEPT_AGREEMENT_REJECTED';
